import { createReducer } from '@reduxjs/toolkit';
import { widgetActions } from './widget.actions';
export const initialState = {};
export const widgetReducer = createReducer(initialState, (builder) => {
    builder.addCase(widgetActions.setPresence, (state, action) => {
        state.presence = action.payload.presence;
    });
});
